module.exports = __webpack_public_path__ + "0f4d92f552d460eb5649bb757369e069.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/TG.svg
// module id = qNpr
// module chunks = 0